'use client';

import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import RequestJoinButton from './request-join-button';
import { useAppContext } from '../../contexts/app';
import { eventPath } from '../../utils/slugify';
import type { Event } from '../../types/Event';

type Props = {
  event: Event;
  onJoin: () => void;
};

const ApprovalRequiredNotice = ({ event, onJoin }: Props) => {
  const { isLoggedIn } = useAppContext();

  if (event.membership?.status === 'DENIED') {
    return (
      <Alert severity="error" sx={{ mb: 2 }}>
        <Typography variant="h3" sx={{ mt: 0 }}>Join request not approved</Typography>
        Your request to join was not approved by the host.
        {event.membership.deniedMessage && (
          <Typography variant="body2" sx={{ mt: 1 }}>
            {event.membership.deniedMessage}
          </Typography>
        )}
      </Alert>
    );
  }

  if (event.membership?.status === 'REQUESTED') {
    return (
      <Alert severity="info" sx={{ mb: 2 }}>
        <Typography variant="h3" sx={{ mt: 0 }}>Request pending</Typography>
        Your request to join is pending host approval. You&apos;ll be notified when a decision is made.
      </Alert>
    );
  }

  const returnTo = !isLoggedIn ? eventPath(event.id, event.name) : undefined;

  return (
    <Alert severity="info" sx={{ mb: 2 }}>
      <Typography variant="h3" sx={{ mt: 0 }}>Approval required</Typography>
      <Typography variant="body2" sx={{ mb: 1 }}>
        Host approval required — location and ride details are hidden until your request is approved.
      </Typography>
      <RequestJoinButton event={event} returnTo={returnTo} onJoin={onJoin} />
    </Alert>
  );
};

export default ApprovalRequiredNotice;
